function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h240v240H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M96.85 105c.098-.485.15-.986.15-1.5v-2a7.5 7.5 0 00-7.5-7.5h-8.906a8 8 0 01.636-1.246l9.934-15.86c2.658 10.813 12.342 18.828 23.881 18.828 13.589 0 24.604-11.115 24.604-24.825 0-.12 0-.242-.002-.362 1.654 2.86 4.728 4.783 8.247 4.783 5.269 0 9.54-4.31 9.54-9.626s-4.271-9.626-9.54-9.626c-4.564 0-8.38 3.233-9.319 7.553a24.866 24.866 0 00-8.427-12.321c2.924-.134 6.078-.225 9.463-.274 16.148-.233 28.443 1.23 36.885 4.387a8 8 0 015.102 6.264l5.305 34.095a8 8 0 01-7.905 9.23H96.85z",
  fill: "#64B5F6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M91.145 166.153l62.013.073c.315-16.02 13.4-28.909 29.494-28.909 16.118 0 29.217 12.927 29.496 28.979l16.664.02 1.405-15.375c-2.663-2.73-3.86-5.106-3.372-7.264 2.47-10.949 3.379-21.937 2.497-26.654-4.571-24.444-11.272-41.24-19.992-50.35-9.2-9.357-18.889-15.932-29.07-19.742-15.477-5.792-58.585-5.97-72.448-.152a88.067 88.067 0 00-3.805 1.68c-2.87 1.367-4.857 2.648-6.808 4.436-2.717 2.49-5.493 6.062-10.421 13.32-1.652 2.432-14.976 22.522-20.727 31.04-1.366 2.022-4.589 3.938-10.057 6.306-2.113.915-4.508 1.876-7.744 3.122-1.126.433-6.901 2.632-8.54 3.265-16.413 6.342-24.312 10.811-25.11 15.27-.814 4.56-.68 11.337.3 26.71.018.278.003.555-.042.833-.088.548-.283 1.068-.588 1.664-.108.21-.224.422-.386.703.02-.034-.298.517-.384.67-.763 1.352-1.07 2.283-1.014 3.462.06 1.265.263 3.537.609 6.801l19.046.023c.39-15.954 13.444-28.767 29.491-28.767 16.07 0 29.14 12.85 29.493 28.836z",
  stroke: "#371447",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  d: "M95.543 103.767l84.976-.45a6.65 6.65 0 006.57-7.681l-5.35-34.078a6.65 6.65 0 00-4.264-5.206c-8.359-3.09-20.65-4.535-36.838-4.304-16.05.23-26.914 1.4-32.476 3.459-1.096.406-3.511 2.843-4.538 4.469L81.118 95.358l1.435-.058c.966-.04 1.652-.064 2.345-.08 2.603-.064 4.43.006 5.682.294.803.185 1.65.526 2.452 1.107 1.215.881 2.05 2.149 2.305 3.798.188 1.22.259 2.336.206 3.348z",
  stroke: "#371447",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("g", {
  fill: "#371447"
}, /*#__PURE__*/React.createElement("g", {
  transform: "rotate(30 -311.59 113.49)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(30 -306.59 132.15)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(30 -301.59 150.81)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(30 -323.099 167.574)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 2,
  cy: 2,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 2,
  cy: 8,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(30 -261.599 397.095)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 2,
  cy: 2,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 2,
  cy: 8,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(30 -326.063 186.368)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 2,
  cy: 2,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 2,
  cy: 8,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(30 -264.563 415.89)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 2,
  cy: 2,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 2,
  cy: 8,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(30 -322.929 205.529)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 2,
  cy: 2,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 2,
  cy: 8,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(30 -261.429 435.05)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 2,
  cy: 2,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 2,
  cy: 8,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(30 -315.063 227.42)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 2,
  cy: 2,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 2,
  cy: 8,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(30 -253.563 456.942)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 2,
  cy: 2,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 2,
  cy: 8,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(30 -275.09 249.71)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(30 -270.09 268.37)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(30 -265.09 287.03)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(30 -260.09 305.691)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(30 -255.09 324.351)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(30 -250.09 343.012)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(30 -245.09 361.672)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(30 -257.385 377.698)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 2,
  cy: 2,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 2,
  cy: 8,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(30 -214.59 475.5)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(30 -209.59 494.16)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
}))), /*#__PURE__*/React.createElement("path", {
  d: "M43.633 152.885A21.897 21.897 0 0040 165c0 12.15 9.85 22 22 22s22-9.85 22-22c0-4.94-1.628-9.5-4.377-13.171m85.01 1.056A21.897 21.897 0 00161 165c0 12.15 9.85 22 22 22s22-9.85 22-22c0-4.94-1.628-9.5-4.377-13.171",
  stroke: "#371447",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("circle", {
  stroke: "#371447",
  strokeWidth: 3,
  cx: 62,
  cy: 165,
  r: 11
}), /*#__PURE__*/React.createElement("circle", {
  stroke: "#371447",
  strokeWidth: 3,
  cx: 183,
  cy: 165,
  r: 11
}), /*#__PURE__*/React.createElement("rect", {
  stroke: "#371447",
  strokeWidth: 3,
  x: 73.5,
  y: 95.5,
  width: 22,
  height: 14,
  rx: 7
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.075 132c2.241.295 3.398.808 3.472 1.539.11 1.108.2 4.292.267 9.553-4.185 2.277-6.79 3.211-7.814 2.804m214.657-12.491c-3.587.359-5.892.335-6.916-.073-.447-.177-.63-4.92-.724-6.872-.081-1.687.13-3 .634-3.941.834-1.018 1.4-1.524 1.697-1.519.894.016 1.56.04 1.999.074",
  stroke: "#371447",
  strokeWidth: 3
}));

function SvgVehiclesXl(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 240,
    viewBox: "0 0 240 240",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgVehiclesXl;